import { useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ApiKeyContext } from '../../App';
import { API_KEY_PARAM_NAME } from '../../constants';

export const ApiKeyWrapper = (props: { children: any }) => {
    const { children } = props;
    const apiKey = useContext(ApiKeyContext);

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if (apiKey && !searchParams.get(API_KEY_PARAM_NAME)) {
            setSearchParams(
                (prev) => {
                    const apiKeySearchParam = prev.get(API_KEY_PARAM_NAME);
                    if (!apiKeySearchParam) {
                        const newParams = new URLSearchParams(prev);
                        newParams.set(API_KEY_PARAM_NAME, apiKey);
                        return newParams;
                    }
                    return prev;
                },
                { replace: true },
            );
        }
    }, [apiKey, searchParams, setSearchParams]);
    return children;
};
